/**
 * This function parses youtube video url and returns the video ID
 * @param url youtube video url
 * @returns video ID or null
 */
export var parseYoutubeVideoId = function parseYoutubeVideoId(url) {
  var youtubeIDRegex = //eslint-disable-next-line no-useless-escape
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|embed|e)\/|.*[?&]v=)|youtu\.be\/)([-\w]{11})/;
  var match = url.match(youtubeIDRegex);
  return match ? match[1] : null;
};